import {createRouter, createWebHistory} from 'vue-router'

import login from '@/pages/login/login'
import loginCode from '@/pages/login/loginCode'
import admin from '@/pages/admin'
import home from '@/pages/home/home'
import performance from '@/pages/performance/index'
import order from '@/pages/order/index'
import detail from '@/pages/order/detail'
import treatorder from '@/pages/treatorder/index'

let router = createRouter({
    // url 地址的转发规则
    history: createWebHistory(),
    // 在routes 中配置路由规则
    routes: [
        {path: '/', component: login, meta: {title: '欢迎登录知夏中医门诊收费系统'}},
        {path: '/login', component: login, meta: {title: '欢迎登录知夏中医门诊收费系统'}},
        {path: '/loginCode', component: loginCode, meta: {title: '知夏中医门诊收费系统短信登录'}},
        {path: '/admin', component: admin, meta: {title: '知夏中医门诊收费系统'},
            redirect: '/admin/home',
            children: [
                {path: 'home', name: 'home', component: home, meta: {title: '工作台'}},
                {path: 'performance', name: 'performance', component: performance, meta: {title: '绩效分析'}},
                {path: 'order', name: 'order', component: order, meta: {title: '门诊订单'}},
                {path: 'detail', name: 'detail', component: detail},
                {path: 'treatorder', name: 'treatorder', component: treatorder, meta: {title: '诊疗工单'}},
            ]
        },
    ]
});
export default router;
